export const FEATURE_GROW_3284_SEEDANCE_LAUNCH_BANNER = 'grow-3284-seedance-launch-banner'
export const FEATURE_GROW_3220_HOMEPAGE_SEEDANCE_25_CARD = 'grow-3220-homepage-seedance-25-card'
export const FEATURE_GROW_3265_HOMEPAGE_TRIAL_BAR = 'grow-3265-homepage-trial-bar'
export const FEATURE_GROW_3415_HOMEPAGE_GET_STARTED_CTA = 'grow-3415-homepage-get-started-cta'
export const FEATURE_GROW_3409_IMAGE_TOOL_SUITE = 'grow-3409-image-tool-suite'
export const FEATURE_GROW_3418_GPT_IMAGE_2_OPEN_HOVER = 'grow-3418-gpt-image-2-open-hover'
